// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"53":"32597d59","96":"5f1ebc5a","233":"41287e59","453":"ce451b92","469":"42221a59","979":"b458a81e","997":"ea9d4178"}[chunkId] + ".chunk.js";
};